export default __webpack_public_path__ + "static/media/shipping.8835ac45.svg";